import DeleteMeasurement from "./DeleteMeasurement";

export default DeleteMeasurement;